<template>
  <div class="m-life">
    <el-row>
      <ul class="nav">
        <li>
          <router-link to="/" class="takeout">美团外卖</router-link>
        </li>
        <li>
          <router-link to="/" class>猫眼电影</router-link>
        </li>
        <li>
          <router-link to="/" class>美团酒店</router-link>
        </li>
        <li>
          <router-link to="/" class="apartment">民宿/公寓</router-link>
        </li>
        <li>
          <router-link to="/" class="business">商家入驻</router-link>
        </li>
        <li>
          <router-link to="/" class>美团公益</router-link>
        </li>
      </ul>
    </el-row>
    <el-row>
      <el-col :span="14" class="w57">
        <Swiper />
      </el-col>
      <el-col :span="4" class="w14">
        <router-link to="//bj.meituan.com/xiuxianyule/">
          <div class="m-life-pic"></div>
        </router-link>
      </el-col>
      <el-col :span="6" class="w23">
        <div class="m-life-login">
          <h4>
            <img
              src="//s0.meituan.net/bs/fe-web-meituan/e350c4a/img/avatar.jpg"
              :style="$store.state.userName ? 'border:4px solid #13D1BE;' : ''"
              alt="用户头像"
            />
          </h4>

          <p class="m-life-login-name">
            Hi！ {{ $store.state.userName ? $store.state.userName : "你好！" }}
          </p>
          <p v-if="!$store.state.userName">
            <router-link :to="{ name: 'register' }">
              <el-button round>注册</el-button>
            </router-link>
          </p>
          <p v-if="!$store.state.userName">
            <router-link :to="{ name: 'login' }">
              <el-button round>立即登录</el-button>
            </router-link>
          </p>
          <p v-else>您已进入美团世界</p>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="7" class="l1">
        <router-link to="//hotel.meituan.com/">
          <div class="m-life-hotel"></div>
        </router-link>
      </el-col>
      <el-col :span="7" class="l1 mln">
        <router-link
          to="https://bj.meituan.com/jiaoyupeixun/?utm_source=MTPCmain-4"
        >
          <div class="m-life-music"></div
        ></router-link>
      </el-col>
      <el-col :span="4" class="w15">
        <router-link to="http://emis.meishi.meituan.com/merchantsSettled">
          <div class="m-life-coop"></div
        ></router-link>
      </el-col>
      <el-col :span="6" class="w22">
        <div class="m-life-downapp">
          <img
            src="//s1.meituan.net/bs/fe-web-meituan/60ac9a0/img/download-qr.png"
            alt="下载APP"
          />
          <p>美团APP手机版</p>
          <p class="last-p">
            <span class="red">
              1元起
            </span>
            吃喝玩乐
          </p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Swiper from "./Swiper.vue";
export default {
  components: {
    Swiper,
  },
};
</script>
<style lang="scss">
@import "@/assets/css/index/life.scss";
</style>
